// Tracks request sequence numbers per key so that when several requests for the
// same data are in flight (e.g. the user changes filters quickly), only the
// response of the most recently started request is used. Older responses that
// arrive late are ignored instead of overwriting newer data.
const sequences = {};

export const startLatestRequest = (key) => {
    const id = (sequences[key] = (sequences[key] || 0) + 1);
    return () => sequences[key] === id;
};
